<template>
  <div id="app">
    <ClosedAppView v-if="closed" />
    <DefaultAppView v-else />
  </div>
</template>

<script>
import DefaultAppView from "@/views/DefaultAppView.vue";
import ClosedAppView from "@/views/ClosedAppView.vue";
export default {
  name: "App",
  components: {
    DefaultAppView,
    ClosedAppView
  },
  data: () => {
    return {
      closed: true
    }
  },
  methods: {}
};
</script>

<style>
#app {
  font-family: "Inter", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
}
</style>
